import { render } from "./CorporateClients.vue?vue&type=template&id=0465c040&scoped=true"
import script from "./CorporateClients.vue?vue&type=script&lang=js"
export * from "./CorporateClients.vue?vue&type=script&lang=js"

import "./CorporateClients.vue?vue&type=style&index=0&id=0465c040&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0465c040"

export default script